import { realityId } from "@/utils/reality-id";
import api from "../api";

export type PdcSyncResponse = {
  synced: boolean;
  /** From sgb-reality-api when synced is false (e.g. PDC_INTEGRATION_DISABLED, PHONE_REQUIRED). */
  reason?: string;
  pdcStatus?: number;
  pdcMessage?: string;
};

/** POST /realities/:realityId/pdc-member/sync — envia o usuário ao PDC após cadastro completo (CPF + profissão, etc.). */
export async function syncPdcMember(): Promise<PdcSyncResponse> {
  const res = await api.post<PdcSyncResponse>(
    `realities/${realityId}/pdc-member/sync`
  );
  return res.data;
}

const RETRYABLE_PDC_HTTP = new Set([502, 503, 504, 429]);

function isRetryablePdcMemberSyncResult(res: PdcSyncResponse): boolean {
  if (res.synced) return false;
  if (res.reason === "PDC_REQUEST_FAILED") return true;
  return (
    res.pdcStatus != null && RETRYABLE_PDC_HTTP.has(res.pdcStatus)
  );
}

/**
 * Same as `syncPdcMember` with a few retries on transient errors (aligned with Nest retries).
 * Use after "Complete seu cadastro" so Reality ↔ PDC link is as reliable as possible.
 */
/** Single post-registration call: extra attempts help transient PDC/network issues without a second user action. */
export async function syncPdcMemberWithRetries(
  maxAttempts = 5
): Promise<PdcSyncResponse> {
  let last: PdcSyncResponse = { synced: false, reason: "PDC_REQUEST_FAILED" };
  for (let i = 0; i < maxAttempts; i++) {
    try {
      last = await syncPdcMember();
    } catch {
      last = { synced: false, reason: "PDC_REQUEST_FAILED" };
    }
    if (last.synced) return last;
    if (i === maxAttempts - 1 || !isRetryablePdcMemberSyncResult(last)) {
      return last;
    }
    await new Promise((r) => setTimeout(r, 500 * (i + 1)));
  }
  return last;
}
